define('drops/requirementsGraph/requirementsgraphimpl',['jquery', 'underscore', 'drops/requirementsGraph/monotoniccubicspline', 'lq/dayTime', 'drops/requirementsGraph/barvalue'],
    function ($, _, MonotonicCubicSpline, dayTime, BarValue) {
        'use strict';
        
        function RequirementsGraphImpl(container) {
            this.container = container;
            this.isMouseDown = false;
            this.previousMouseMovePosition = undefined;
            this.graphData = null;
            this.graphModel = null;
        };

        RequirementsGraphImpl.prototype.roundFloat = function(x) {
            return (Math.round(x * 100) / 100);
        };

        RequirementsGraphImpl.prototype.compareFloats = function(x, y) {
            return (Math.round(x * 100) / 100) == (Math.round(y * 100) / 100);
        };

        RequirementsGraphImpl.prototype.getYPosition = function(realYValue) {
            return _.find(this.graphModel.yIntervals, function (yInterval) {
                return yInterval.real == realYValue;
            }).percentual;
        };

        RequirementsGraphImpl.prototype.getXPosition = function(realXValue) {
            return _.find(this.graphModel.xIntervals, function (xInterval) {
                return xInterval.real == realXValue;
            }).percentual;
        };

        RequirementsGraphImpl.prototype.getRealYPosition = function (percentualYValue) {
            var self = this;
            return _.find(self.graphModel.yIntervals, function (yInterval) {
                return self.compareFloats(yInterval.percentual, percentualYValue);
            }).real;
        };

        RequirementsGraphImpl.prototype.getRealXPosition = function (percentualXValue) {
            var self = this;
            return _.find(self.graphModel.xIntervals, function (xInterval) {
                return self.compareFloats(xInterval.percentual, percentualXValue);
            }).real;
        };

        RequirementsGraphImpl.prototype.calculateYPosition = function(value) {
            return (value - this.graphData.yAxisFrom) / (this.graphData.yAxisTo - this.graphData.yAxisFrom) * 100;
        };

        RequirementsGraphImpl.prototype.calculateXPosition = function(value) {
            return (value - this.graphData.xAxisFrom) / (this.graphData.xAxisTo - this.graphData.xAxisFrom) * 100;
        };

        RequirementsGraphImpl.prototype.getBarValue = function(realXValue) {
            return _.find(this.graphModel.barValues, function (barValue) {
                return barValue.xValue == realXValue;
            });
        };

        RequirementsGraphImpl.prototype.createGraphModel = function() {
            this.graphModel = {
                xSubIntervalWidth: this.calculateXPosition(this.graphData.xAxisFrom + this.graphData.xAxisSubInterval),
                xIntervalWidth: this.calculateXPosition(this.graphData.xAxisFrom + this.graphData.xAxisInterval),
                ySubIntervalWidth: this.calculateYPosition(this.graphData.yAxisFrom + this.graphData.yAxisSubInterval),
                yIntervalWidth: this.calculateYPosition(this.graphData.yAxisFrom + this.graphData.yAxisInterval),
                xIntervals: this.generateXIntervals(),
                yIntervals: this.generateYIntervals(),
                barValues: this.graphData.barValues == undefined ? [] : this.graphData.barValues
            };
        };

        RequirementsGraphImpl.prototype.generateXIntervals = function() {
            var xIntervals = [];

            for (var x = this.graphData.xAxisFrom; x <= this.graphData.xAxisTo; x = x + this.graphData.xAxisSubInterval) {
                xIntervals.push({
                    real: x,
                    percentual: this.calculateXPosition(x)
                });
            }

            return xIntervals;
        };

        RequirementsGraphImpl.prototype.generateYIntervals = function() {
            var yIntervals = [];

            for (var y = this.graphData.yAxisFrom; y <= this.graphData.yAxisTo; y = y + this.graphData.yAxisSubInterval) {
                yIntervals.push({
                    real: y,
                    percentual: this.calculateYPosition(y)
                });
            }

            return yIntervals;
        };

        RequirementsGraphImpl.prototype.createGraph = function() {
            var graph = $('<div>', {
                'class': 'graph'
            });

            this.createGraphContainer(graph);

            if (this.graphData.showAxisLabels) {
                this.createXAxis(graph);
                this.createYAxis(graph);
            }

            graph.appendTo($(this.container));
        };

        RequirementsGraphImpl.prototype.createXAxis = function(graph) {
            var xAxis = $('<ul>').
                addClass('xAxis');

            for (var x = this.graphData.xAxisFrom; x < this.graphData.xAxisTo; x = x + this.graphData.xAxisInterval) {
                $('<li>', {
                    css: {
                        width: this.graphModel.xIntervalWidth + '%',
                        'margin-left': -this.graphModel.xIntervalWidth / 2 + '%',
                        'margin-right': this.graphModel.xIntervalWidth / 2 + '%'
                    },
                    text: this.graphData.xAxisShowAsTime ? dayTime.fromTicks(x) : x
                }).appendTo(xAxis);
            }

            graph.append(xAxis);
        };

        RequirementsGraphImpl.prototype.createYAxis = function(graph) {
            var yAxis = $('<ul>').
                addClass('yAxis');

            for (var y = this.graphData.yAxisTo; y >= this.graphData.yAxisFrom; y = y - this.graphData.yAxisInterval) {
                $('<li>', {
                    css: {
                        height: this.graphModel.yIntervalWidth + '%'
                    },
                    text: this.graphData.yAxisShowAsTime ? dayTime.fromTicks(y) : y
                }).appendTo(yAxis);
            }

            graph.append(yAxis);
        };

        RequirementsGraphImpl.prototype.createGraphContainer = function(graph) {
            var outerGraphContainer = $('<div>')
                .addClass('graphContainer')
                .addClass('outerGraphContainer')
                .css({
                    width: '100%',
                    height: '100%'
                })
                .appendTo(graph);

            var graphContainer = $('<div>')
                .addClass('graphContainer')
                .addClass('innerGraphContainer')
                .css({
                    width: '100%',
                    height: '100%',
                    cursor: this.graphData.readOnly ? 'default' : 'pointer'
                });

            if (!this.graphData.readOnly) {
                this.addChangeBarListeners(graphContainer);
            }

            this.createGridLines(graphContainer);
            this.createGraphBars(graphContainer);

            graphContainer.appendTo(outerGraphContainer);
        };

        RequirementsGraphImpl.prototype.createGridLines = function(graphContainer) {
            for (var x = this.graphData.xAxisFrom; x < this.graphData.xAxisTo; x = x + this.graphData.xAxisSubInterval) {
                if ((x + this.graphData.xAxisSubInterval) % this.graphData.xAxisInterval == 0) {
                    this.createVerticalGridDiv(graphContainer, x)
                        .addClass('intervalGrid');
                }
                else {
                    this.createVerticalGridDiv(graphContainer, x)
                        .addClass('subIntervalGrid');
                }
            }
            for (var y = this.graphData.yAxisFrom; y < this.graphData.yAxisTo; y = y + this.graphData.yAxisSubInterval) {
                if ((y + this.graphData.yAxisSubInterval) % this.graphData.yAxisInterval == 0) {
                    this.createHorizontalGridDiv(graphContainer, y)
                        .addClass('intervalGrid');
                }
                else {
                    this.createHorizontalGridDiv(graphContainer, y)
                        .addClass('subIntervalGrid');
                }
            }
        };

        RequirementsGraphImpl.prototype.createHorizontalGridDiv = function(graphContainer, yValue) {
            return this.createGridDiv(graphContainer, 100 - this.getYPosition(yValue + this.graphData.yAxisSubInterval), 0, this.getYPosition(yValue), 0);
        };

        RequirementsGraphImpl.prototype.createVerticalGridDiv = function(graphContainer, xValue) {
            var gridDiv = this.createGridDiv(graphContainer, 0, 100 - this.getXPosition(xValue + this.graphData.xAxisSubInterval), 0, this.getXPosition(xValue));
            return gridDiv.addClass('vertical');
        };

        RequirementsGraphImpl.prototype.createGridDiv = function(graphContainer, top, right, bottom, left) {
            return $('<div>', {
                'class': 'gridBar',
                css: {
                    top: top + '%',
                    right: right + '%',
                    left: left + '%',
                    bottom: bottom + '%'
                }
            }).appendTo(graphContainer);
        };

        RequirementsGraphImpl.prototype.addChangeBarListeners = function(graphContainer) {
            var self = this;
            graphContainer.on('mousedown', function (e) {
                self.onMouseMoveStart(e, this);
            });
            graphContainer.on('mouseleave', function (e) {
                self.onMouseMoveEnd(e, this);
            });
            graphContainer.on('mouseup', function (e) {
                self.onMouseMoveEnd(e, this);
            });
            graphContainer.on('mousemove', function (e) {
                self.onMouseMove(e, this);
            });
        };

        RequirementsGraphImpl.prototype.onMouseMove = function (e, handler) {
            if (this.isMouseDown) {
                this.locateAndChangeBar({ x: e.pageX, y: e.pageY }, handler);
            }
        };

        RequirementsGraphImpl.prototype.onMouseMoveEnd = function (e, handler) {
            if (this.isMouseDown) {
                this.locateAndChangeBar({ x: e.pageX, y: e.pageY }, handler);
            }

            this.isMouseDown = false;
            this.previousMouseMovePosition = undefined;
        };

        RequirementsGraphImpl.prototype.onMouseMoveStart = function (e, handler) {
            this.isMouseDown = true;
        };

        RequirementsGraphImpl.prototype.calculateRelativeMousePosition = function(mousePosition, graphContainer) {
            var point = { x: 0, y: 0 };

            var offset = $(graphContainer).offset();
            point.x = (mousePosition.x - offset.left) / graphContainer.scrollWidth * 100;
            var limitedMousePositionY = mousePosition.y < offset.top
                ? offset.top
                : mousePosition.y > offset.top + graphContainer.scrollHeight
                ? offset.top + graphContainer.scrollHeight
                : mousePosition.y;

            point.y = Math.abs((limitedMousePositionY - offset.top) / graphContainer.scrollHeight * 100 - 100);

            return point;
        };

        RequirementsGraphImpl.prototype.locateAndChangeBar = function(mousePosition, graphContainer) {
            var relativeMousePosition = this.calculateRelativeMousePosition(mousePosition, graphContainer);

            if (this.previousMouseMovePosition != undefined) {
                var amountOfIntervalsBetweenPositions = Math.round(Math.abs(relativeMousePosition.x - this.previousMouseMovePosition.x) / this.graphModel.xSubIntervalWidth);
                if (amountOfIntervalsBetweenPositions > 0) {
                    var cubicSpline;
                    var positivity;
                    if (relativeMousePosition.x - this.previousMouseMovePosition.x <= 0) {
                        cubicSpline = new MonotonicCubicSpline([relativeMousePosition.x, this.previousMouseMovePosition.x],
                                                               [relativeMousePosition.y, this.previousMouseMovePosition.y]);
                        positivity = -1;
                    }
                    else {
                        cubicSpline = new MonotonicCubicSpline([this.previousMouseMovePosition.x, relativeMousePosition.x],
                                                               [this.previousMouseMovePosition.y, relativeMousePosition.y]);
                        positivity = 1;
                    }
                    for (var i = 1; i <= amountOfIntervalsBetweenPositions; i++) {
                        var simulatedXPosition = this.previousMouseMovePosition.x + (i * positivity * this.graphModel.xSubIntervalWidth);
                        var simulatedYPosition = cubicSpline.interpolate(simulatedXPosition);
                        if (!isNaN(simulatedYPosition)) {
                            var simulatedMousePosition = {
                                x: this.snapXCoordinateToLowestSubInterval(simulatedXPosition),
                                y: this.snapYCoordinateToClosestSubInterval(simulatedYPosition)
                            };
                            this.renderBarChange(graphContainer, simulatedMousePosition.x, simulatedMousePosition.y);
                        }
                    }
                }
            }
            this.previousMouseMovePosition = {
                x: relativeMousePosition.x,
                y: relativeMousePosition.y
            };

            var snappedX = this.snapXCoordinateToLowestSubInterval(relativeMousePosition.x);
            var snappedY = this.snapYCoordinateToClosestSubInterval(relativeMousePosition.y);

            this.renderBarChange(graphContainer, snappedX, snappedY);
        };

        RequirementsGraphImpl.prototype.snapXCoordinateToLowestSubInterval = function (x) {
            var self = this;
            var test = _.find(this.graphModel.xIntervals, function (xInterval) {
                var difference = self.roundFloat(x - xInterval.percentual);
                return difference >= 0 && difference < self.graphModel.xSubIntervalWidth;
            });

            if (!test) {
                if (x > 100) return 100;
                if (x < 0) return 0;
            }

            return test.percentual;
        };

        RequirementsGraphImpl.prototype.snapYCoordinateToClosestSubInterval = function (y) {
            var self = this;
            var closestYIntervals = _.filter(this.graphModel.yIntervals, function (yInterval) {
                var difference = self.roundFloat(y - yInterval.percentual);
                if (difference >= 0 && difference < self.graphModel.ySubIntervalWidth) return true;
                if (difference <= 0 && difference > -self.graphModel.ySubIntervalWidth) return true;
                return false;
            });

            if (closestYIntervals.length == 0) {
                if (y > 100) return 100;
                if (y < 0) return 0;
            }
            if (closestYIntervals.length == 1) return closestYIntervals[0].percentual;

            if (Math.abs(closestYIntervals[0].percentual - y) < Math.abs(closestYIntervals[1].percentual - y)) {
                return closestYIntervals[0].percentual;
            } else {
                return closestYIntervals[1].percentual;
            }

        };

        RequirementsGraphImpl.prototype.renderBarChange = function(graphContainer, snappedX, snappedY) {
            if (!this.graphData.isWithPreferredValues) {
                this.changeBarSize(graphContainer, snappedX, snappedY);
            } else {
                this.changePreferredBarSize(graphContainer, snappedX, snappedY);
            }
        };

        RequirementsGraphImpl.prototype.changeBarSize = function(graphContainer, x, y) {
            var xValue = this.getRealXPosition(x);
            var barValue = this.getBarValue(xValue);
            var bar = $(graphContainer).children("div.bar.selected[data-xvalue='" + xValue + "']");
            var barsContainer = $(graphContainer).children("div.barsContainer[data-xvalue='" + xValue + "']");

            if (bar[0] == undefined || barsContainer[0] == undefined) return;

            barValue.selectedValue = this.getRealYPosition(y);
            barsContainer.prop('title', this.createGraphBarTitle(barValue));

            bar.animate({ top: 100 - y + '%' }, { duration: 150, easing: 'swing', queue: false });
            barsContainer.animate({ top: 100 - y + '%' }, { duration: 150, easing: 'swing', queue: false });

            if (y != 0) {
                bar.removeClass('collapsed');
            } else {
                bar.addClass('collapsed');
            }
        };

        RequirementsGraphImpl.prototype.changePreferredBarSize = function(graphContainer, x, y) {
            var xValue = this.getRealXPosition(x);
            var barValue = this.getBarValue(xValue);

            var selectedBar = $(graphContainer).children("div.bar.selected[data-xvalue='" + xValue + "']");
            var preferredBar = $(graphContainer).children("div.bar.preferred[data-xvalue='" + xValue + "']");
            var barsContainer = $(graphContainer).children("div.barsContainer[data-xvalue='" + xValue + "']");

            barValue.preferredValue = this.getRealYPosition(y);
            barsContainer.prop('title', this.createGraphBarTitle(barValue));

            preferredBar.removeClass('plus');
            preferredBar.removeClass('minus');
            preferredBar.removeClass('collapsed');

            var selectedBarHeight = this.getYPosition(barValue.selectedValue);
            if (y < selectedBarHeight) {
                preferredBar.addClass('minus');
                this.switchToMinusColor(preferredBar);
                preferredBar.animate({ top: 100 - selectedBarHeight + '%', bottom: y + '%' }, { duration: 250, easing: 'swing', queue: false });
                barsContainer.animate({ top: 100 - selectedBarHeight + '%' }, { duration: 250, easing: 'swing', queue: false });
            }
            else if (y > selectedBarHeight) {
                preferredBar.addClass('plus');
                this.switchToPlusColor(preferredBar);
                preferredBar.animate({ top: 100 - y + '%', bottom: selectedBarHeight + '%' }, { duration: 250, easing: 'swing', queue: false });
                barsContainer.animate({ top: 100 - y + '%' }, { duration: 250, easing: 'swing', queue: false });
            }
            else {
                preferredBar.addClass('collapsed');
                preferredBar.animate({ top: 100 - selectedBarHeight + '%', bottom: selectedBarHeight + '%' }, { duration: 250, easing: 'swing', queue: false });
                barsContainer.animate({ top: 100 - selectedBarHeight + '%' }, { duration: 250, easing: 'swing', queue: false });
            }
        };

        RequirementsGraphImpl.prototype.createGraphBars = function(graphContainer) {
            for (var i = this.graphData.xAxisFrom; i < this.graphData.xAxisTo; i = i + this.graphData.xAxisSubInterval) {
                if (i < this.graphData.xAxisMin || i >= this.graphData.xAxisMax) {
                    this.createInvalidGraphBar(graphContainer, new BarValue(null, i, this.graphData.yAxisTo));
                }
                if (_.any(this.graphModel.barValues, function (barValue) { return barValue.xValue == i; })) {
                    var barValue = _.find(this.graphModel.barValues, function (barValue) { return barValue.xValue == i; });
                    this.createGraphBar(graphContainer, barValue);
                }
                else {
                    var newBarValue = new BarValue(null, i, this.graphData.yAxisFrom);
                    this.graphModel.barValues.push(newBarValue);
                    this.createGraphBar(graphContainer, newBarValue);
                }
            }
        };

        RequirementsGraphImpl.prototype.createGraphBarTitle = function(barValue) {
            var selectedString = 'Planning: ' + barValue.selectedValue;
            if (this.graphData.isWithPreferredValues) {
                return selectedString + '\nSchedule: ' + barValue.preferredValue;
            }
            return selectedString;
        };

        RequirementsGraphImpl.prototype.createGraphBar = function(graphContainer, barValue) {
            var xPosition = this.getXPosition(barValue.xValue);
            var xPlusOnePosition = this.getXPosition(barValue.xValue + this.graphData.xAxisSubInterval);
            var yPosition = this.getYPosition(barValue.selectedValue);

            var barsContainer = $('<div>', {
                'class': 'verticalBar barsContainer',
                'data-xvalue': barValue.xValue,
                'title': this.createGraphBarTitle(barValue),
                css: {
                    left: xPosition + '%',
                    right: 100 - xPlusOnePosition + '%',
                    top: 100 - yPosition + '%',
                    bottom: 0 + '%'
                }
            }).appendTo(graphContainer);

            barsContainer
                .on('mouseenter', function () {
                    barsContainer.addClass('barSelector');
                })
                .on('mouseleave', function () {
                    barsContainer.removeClass('barSelector');
                });

            $('<div>', {
                'class': 'verticalBar bar selected' + (yPosition != 0 ? '' : ' collapsed'),
                'data-xvalue': barValue.xValue,
                css: {
                    left: xPosition + '%',
                    right: 100 - xPlusOnePosition + '%',
                    top: 100 - yPosition + '%',
                    bottom: 0 + '%'
                }
            }).appendTo(graphContainer);

            if (this.graphData.isWithPreferredValues) {
                var yPositionOfPreferredValue = this.getYPosition(barValue.preferredValue);
                var isPreferredPlus = yPositionOfPreferredValue > yPosition;

                var topLocation = isPreferredPlus ? 100 - yPositionOfPreferredValue : 100 - yPosition;
                var bottomLocation = isPreferredPlus ? yPosition : yPositionOfPreferredValue;
                var preferredBar = $('<div>', {
                    'class': 'verticalBar bar preferred ' + (isPreferredPlus ? 'plus' : 'minus') + (yPositionOfPreferredValue != yPosition ? '' : ' collapsed'),
                    'data-xvalue': barValue.xValue,
                    css: {
                        left: xPosition + '%',
                        right: 100 - xPlusOnePosition + '%',
                        top: topLocation + '%',
                        bottom: bottomLocation + '%',
                    }
                }).appendTo(graphContainer);

                if (isPreferredPlus) {
                    barsContainer.css({ top: 100 - yPositionOfPreferredValue + '%' });
                }
                if (isPreferredPlus) {
                    preferredBar.addClass('plusPreferred');
                } else {
                    preferredBar.addClass('minusPreferred');
                }
            }
        };
        
        RequirementsGraphImpl.prototype.createInvalidGraphBar = function(graphContainer, barValue) {
            var xPosition = this.getXPosition(barValue.xValue);
            var xPlusOnePosition = this.getXPosition(barValue.xValue + this.graphData.xAxisSubInterval);
            var yPosition = this.getYPosition(barValue.selectedValue);

            $('<div>', {
                'class': 'verticalBar bar invalid',
                css: {
                    left: xPosition + '%',
                    right: 100 - xPlusOnePosition + '%',
                    top: 100 - yPosition + '%',
                    bottom: 0 + '%'

                }
            }).appendTo(graphContainer);
        };

        RequirementsGraphImpl.prototype.deleteGraph = function() {
            $(this.container).children().remove();
        };

        RequirementsGraphImpl.prototype.getBarValues = function () {
            return this.graphModel.barValues;
        };

        RequirementsGraphImpl.prototype.draw = function (selectedGraphData) {
            this.deleteGraph();

            this.graphData = selectedGraphData;

            this.createGraphModel();
            this.createGraph();
        };

        return RequirementsGraphImpl;
    });
